import { Controller } from "@hotwired/stimulus"

// Cambia el badge "Requerido" a un check verde cuando hay al menos 1 ingrediente seleccionado
export default class extends Controller {
  static targets = ["badge", "checkbox", "stepper"]

  connect() {
    this.updateStatus()
  }

  // Llamado cuando cambia un checkbox o stepper
  updateStatus() {
    const hasSelection = this.hasAnySelection()

    if (this.hasBadgeTarget) {
      if (hasSelection) {
        // Cambiar a check verde
        this.badgeTarget.innerHTML = '<i class="bi bi-check-circle-fill"></i>'
        this.badgeTarget.classList.remove('required-ingredients')
        this.badgeTarget.classList.add('fulfilled-ingredients')
      } else {
        // Volver a "Requerido"
        this.badgeTarget.innerHTML = 'Requerido'
        this.badgeTarget.classList.remove('fulfilled-ingredients')
        this.badgeTarget.classList.add('required-ingredients')
      }
    }
  }

  hasAnySelection() {
    // Verificar checkboxes (hidden inputs with value 0/1)
    if (this.hasCheckboxTarget) {
      const anySelected = this.checkboxTargets.some(cb => parseInt(cb.value || 0) > 0)
      if (anySelected) return true
    }

    // Verificar steppers (inputs con cantidad > 0)
    if (this.hasStepperTarget) {
      const anyWithQty = this.stepperTargets.some(input => parseInt(input.value || 0) > 0)
      if (anyWithQty) return true
    }

    return false
  }
}
